import React from "react";

import "./ChatWidgetMainView.css";

import { CrossWhite, BackIcon } from "../../assets/Svg-icons/index";
import { User } from "../../assets/images/index";
import PostMessageContext from "../../context/PostMessageContext";
import DefaultAvatar from '../../assets/images/bot-avatar.png'

class ChatWidgetMainViewHeader extends React.Component {
    renderAgentBar = (widgetSettings) => {
        const { agentData, isBotEnable, botAvatar, botName } = this.props;
        return (
            <div className="agent-bar-wrapper fadeIn animated fast delay-1s ">
                <div
                    className="agent-bar"
                    style={{
                        backgroundColor: widgetSettings.Appearance.AgentBarColor,
                        // backgroundColor: "#FFF",
                        color: widgetSettings.Appearance.AgentBarTextColor
                        // color:"black",
                    }}
                >
                    <div className="agent-profile-picture-wrapper">
                        <div className="agent-profile-picture">
                            <div className="avatar-wrapper">
                                <div className="avatar">
                                    {!isBotEnable ? <img
                                        src={agentData.imageUrl ? agentData.imageUrl : User}
                                        alt="agent-dp"
                                    />: 
                                    <img src={botAvatar ? botAvatar : DefaultAvatar} alt="agent-dp"
                                />}
                                </div>
                            </div>
                        </div>
                    </div>
                    {!isBotEnable ?<div>
                        <div className="agent-name">{agentData.Name}</div>
                        {/* <div className="agent-title">Support Agent</div> */}
                    </div>:
                    <div>
                        <div className="agent-name">{botName}</div>
                    </div>
                    }
                </div>
            </div>
        );
    };

    render() {
        const {
            crossIconStyle,
            onMenuClick,
            onCrossClick,
            onBackIconClick,
            headerWrapperHeight,
            emailForm,
            agentsOffline,
            widgetIntegrated,
            isBotEnable,
            // botName,
            agentJoined,
            // agentData,
            // botAvatar
        } = this.props;
        return (
            <PostMessageContext.Consumer>
                {({ widgetSettings }) => (
                    <div className="chat-header-wrapper-smooth" style={headerWrapperHeight}>
                        <div
                            className={`chat-header-smooth ${widgetIntegrated &&
                                "widget-intergrate"}`}
                            style={{
                                color: widgetSettings.Appearance.TitleBarTextColor,
                                backgroundColor: widgetSettings.Appearance.TitleBarColor
                            }}
                        >
                            {!emailForm && (!agentsOffline || isBotEnable) &&(
                                <div
                                    className={`dotted-overflow-wrapper ${widgetIntegrated ? "right-dotted-overflow-wrapper" : null
                                        }`}
                                >
                                    <div className="dotted-overflow" onClick={onMenuClick}>
                                        <span className="dot"></span>
                                        <span className="dot"></span>
                                        <span className="dot"></span>
                                    </div>
                                </div>
                            )}
                            
                            <div
                                className={`company-name-wrapper ${!agentsOffline || isBotEnable ? "text-center":""} ${widgetIntegrated ? "company-name-wrapper-integrated" : null
                                    } `}
                            >
                                <div className="company-name">
                                    {
                                        !agentsOffline || isBotEnable
                                        ? widgetSettings.Appearance.TitleBarText
                                        : "Offline"
                                    }
                                </div>
                            </div>
                            {!widgetIntegrated && (
                                <div
                                    className="chat-close"
                                    style={{ crossIconStyle }}
                                    onClick={onCrossClick}
                                >
                                    <img src={CrossWhite} alt="cross-icon" />
                                </div>
                            )}

                            {widgetIntegrated && (
                                <div
                                    className="chat-back-icon"
                                    style={{ crossIconStyle }}
                                    onClick={onBackIconClick}
                                >
                                    <img src={BackIcon} alt="back-icon" />
                                </div>
                            )}
                        </div>
                        {!(emailForm && ((widgetSettings.Behaviour.PreChatFormEnabled) || (!widgetSettings.Behaviour.ChatBotEnabled && widgetSettings.Behaviour.OfflineFormEnabled))) && (agentJoined || isBotEnable) ? this.renderAgentBar(widgetSettings) : null}
                    </div>
                )}
            </PostMessageContext.Consumer>
        );
    }
}

export default ChatWidgetMainViewHeader;
